<template>
    <div class="form-field">
        <label
            class="checkbox-field"
            :for="checkBoxId"
            @click.stop
        >
            <input
                :id="checkBoxId"
                type="checkbox"
                :checked="modelValue"
                class="checkbox-field__input"
                @change="$emit('update:modelValue', $event.target.checked)"
            />

            <span :class="['checkbox-field__custom', { 'checkbox-field__custom_error': hasError }]">
                <span v-if="modelValue">
                    <img
                        v-svg-inline
                        src="@/assets/icons/ui/check.svg"
                        class="checkbox-field__check-icon"
                    />
                </span>
            </span>

            <span class="checkbox-field__title">
                <slot></slot>
            </span>
        </label>

        <span v-if="hasError" class="form-field__error">
            {{ errorMessage }}
        </span>
    </div>
</template>

<script lang="ts" setup>
    import { computed, defineProps, defineEmits, useId } from 'vue';

    const props = defineProps({
        modelValue: {
            type: Boolean,
            required: true,
        },
        errorMessage: {
            type: String,
            default: '',
        },
    });

    defineEmits<{
        (e: 'update:modelValue', value: boolean): void,
    }>();

    const hasError = computed(() => !!props.errorMessage);

    const checkBoxId = useId();
</script>

<style lang="scss" scoped>
    @use './UICheckbox.scss' as *;
</style>
